import { Clock, Users, Target, BookOpen } from 'lucide-react';
import { usePricing, formatPrice } from '../context/PricingContext';

/**
 * Clean info strip above the subject grid — consolidates the info shared
 * by all subjects (price, duration, max group, target grade, exam board)
 * so it doesn't need to be repeated on every card.
 */
const CourseInfoBanner = ({
  price,
  duration = '2 hours',
  maxStudents = 8,
  targetGrade = 'A* - B',
  examBoard,
  context,
}) => {
  const pricing = usePricing();

  const stats = [
    { icon: Clock,    label: duration },
    { icon: Users,    label: `Max ${maxStudents} students` },
    { icon: Target,   label: `Target ${targetGrade}` },
    ...(examBoard ? [{ icon: BookOpen, label: examBoard }] : []),
  ];

  return (
    <div className="bg-white rounded-2xl border-2 border-gray-100 shadow-sm p-4 sm:p-6 mb-6 sm:mb-8">
      <div className="flex flex-wrap items-center gap-x-6 sm:gap-x-8 gap-y-3">
        {/* Price — most prominent */}
        <div>
          <span className="font-mono font-extrabold text-2xl sm:text-3xl text-gray-900 leading-none">
            {formatPrice(price, pricing)}
          </span>
          <span className="text-sm text-gray-400 ml-2">/ session</span>
        </div>

        <div className="hidden sm:block h-8 w-px bg-gray-200" />

        {/* Stats */}
        {stats.map(({ icon: Icon, label }) => (
          <div key={label} className="flex items-center gap-2 text-sm text-gray-500">
            <Icon className="w-4 h-4 text-gray-400 flex-shrink-0" />
            <span className="font-medium">{label}</span>
          </div>
        ))}
      </div>

      {context && (
        <p className="text-xs text-gray-400 mt-3 font-medium">{context}</p>
      )}
    </div>
  );
};

export default CourseInfoBanner;
